import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../scss/project-management.scss";
import {
  receiveDEStock,
  getProject,
  getPOList as getPOListAPI,
  receiveReserveStock,
} from "../../../actions/project-management.action";
import {
  listCategories
} from "../../../actions/inventory.action";
import { getItems as getItemsAPI } from "../../../actions/inventory.action";
import { warningSnackBar } from "../../../actions/common.action";
import { PROJECT_MANAGEMENT } from "../../../constants/route-paths";
import _ from "lodash";
import idx from "idx";
import { resolveProjectType } from "../utils/resolve-project-type";
import { useParams, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import '../scss/task.scss';
import SelectInput from "../../../components/inputs/select";
import CustomInput from "../../../components/inputs/new-input";
import { extractLastStageData } from "../../../util/common";
import MultiSelect from "src/components/inputs/multi-select";
import { convertToReactSelectFormat } from "../../../util/section-dropdown-format";

const ReceiveStock = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const categoryList = useSelector((state) => state.catalog.catalogs);
  const projectState = useSelector((state) => state.project);
  // const userAccessControl = useSelector(state => state.auth?.userDetail?.userAccessControl);

  const [items, setItems] = useState([]);
  const [projectId, setProjectId] = useState(params.projectId);
  const [tasksList, setTasksList] = useState([]);
  const [reservedStock, setReservedStock] = useState(false);
  const [projectName, setProjectName] = useState("");
  const [projectType, setProjectType] = useState("");
  const [unifiedTasks, setUnifiedTasks] = useState([]);
  const [selectedTaskData, setSelectedTaskData] = useState(null);

  useEffect(() => {
    if (categoryList) dispatch(listCategories());
    let _reservedStock = false;
    if (location.pathname.includes("reserved")) _reservedStock = true;

    setProjectId(params.projectId);
    setReservedStock(_reservedStock);
    if (projectId) getStages();
  }, []);

  useEffect(() => {
    if (selectedTaskData) getItemsList();
  }, [selectedTaskData]);

  const getItemsList = () => {
    if (reservedStock) getPoList();
    else getItems();
  };

  const getPoList = async () => {
    let poList;

    if (projectId) {
      poList = await dispatch(getPOListAPI({ projectId, vendorType: "Supplier" })).catch(e => console.error(e));
    }
    const categories = {};

    Array.isArray(categoryList) && categoryList.forEach(({ id, name }) => {
      categories[id] = name;
    });

    const stockItems = [];
    Array.isArray(poList.list) && poList.list.map(({ items }) => {
      Array.isArray(items) && items.map((item) => {
        if (_.isObject(item.stock) && parseFloat(item.stock.warehouse || 0) > 0) {
          const itemIndex = stockItems.findIndex((_item) => _item.id === item.id);
          if (itemIndex > -1) {
            stockItems[itemIndex].reservedStock = parseFloat(stockItems[itemIndex].reservedStock || 0) + parseFloat(item.stock.warehouse || 0);
          } else {
            item.category = categories[item.categoryId];
            item.reservedStock = parseFloat(item.stock.warehouse || 0);
            stockItems.push(item);
          }
        }
      });
    });

    setItems(stockItems);
  };

  const getStages = async () => {
    const project = await dispatch(getProject(projectId));

    const _projectName = idx(project, (_) => project.name) || "";
    // Format stages for unified dropdown like WO order (show all tasks)
    const prepareData = (data) => {
      if (!Array.isArray(data)) return [];
      return data.map(section => ({
        ...section,
        isHistoricalView: true, // This ensures convertToReactSelectFormat shows all tasks/stages
        stages: section.stages ? prepareData(section.stages) : []
      }));
    };

    const formatted = convertToReactSelectFormat(prepareData(idx(project, (_) => project.stages) || []), null, true);

    setUnifiedTasks(formatted);
    setProjectName(_projectName);
    setProjectType(resolveProjectType(idx(project, _ => _.projectType), projectState));
  };

  const getItems = async () => {
    let itemsList = await dispatch(getItemsAPI()).catch(e => console.error(e));
    const _items = [];

    Array.isArray(itemsList) && itemsList.map((item) => {
      let allowItem = false;
      if (reservedStock && parseFloat(item.reservedStock || 0) > 0) allowItem = true;
      else if (!reservedStock && parseFloat(item.deStock || 0) > 0) allowItem = true;

      if (allowItem)
        _items.push({
          ...item,
          category: idx(item, (_) => _.category.name) || "",
        });
    });

    setItems(_items);
  };

  const itemChangeHandler = (e, index) => {
    const _items = _.cloneDeep(items);
    const item = _items[index];
    const enteredValue = parseFloat(e.target.value || 0);

    if (enteredValue < 0) return;

    let availableStock;

    if (reservedStock) availableStock = parseFloat(item.reservedStock || 0);
    else availableStock = parseFloat(item.deStock || 0);


    if (enteredValue > availableStock) _items[index].error = "You can not enter more than available Stock";
    else _items[index].error = false;

    _items[index].newStock = enteredValue;
    setItems(_items);
  };

  const viewProject = () => {
    navigate(`/${PROJECT_MANAGEMENT}/view/${projectId}`);
  };

  const submitForm = async () => {
    let isFormValid = true;

    items && items.forEach((item) => {
      if (item.error) isFormValid = false;
    });

    if (!selectedTaskData) {
      dispatch(warningSnackBar("Please Select Task"));
      return;
    }

    if (isFormValid) {
      const data = {
        allocationLocation: "SITE",
        transactionType: "ALLOCATED",
      };

      data.taskType = selectedTaskData.taskType || (selectedTaskData.isStage ? "STAGE" : "TASK");
      data.taskId = selectedTaskData.value;
      data.allocateToName = projectId ? projectName : "";
      data.allocateToId = projectId;
      data.poId = reservedStock ? "RESERVED STOCK" : "INTERNAL Stock";
      data.receivedFrom = "WAREHOUSE";

      const _projectType = projectId ? "PROJECT" : "SERVICE";
      const receivedFrom = reservedStock ? "RESERVED_STOCK" : "INTERNAL_STOCK";

      const selectedItems = [];
      Array.isArray(items) && items.forEach((item) => {
        if (item.newStock) {
          delete item.deStock;
          item.cost =
            parseFloat(item.recommendedCost) > 0
              ? parseFloat(item.recommendedCost)
              : parseFloat(item.cost);
          item.newStock = -Math.abs(parseFloat(item.newStock) || 0);
          item.taskType = data.taskType;
          item.taskId = data.taskId;
          item.projectType = _projectType;
          item.receivedFromStock = receivedFrom;
          selectedItems.push(item);
        }
      });

      if (selectedItems.length === 0) {
        dispatch(warningSnackBar("Please Enter Stock in atleast one item"));
        return;
      }

      data.items = selectedItems;
      if (reservedStock) {
        if (projectId) {
          data.projectId = projectId;
          await dispatch(receiveReserveStock(data)).catch(e => console.error(e));
          getItemsList();
        }
      } else if (projectId) {
        await dispatch(receiveDEStock(data)).catch(e => console.error(e));
        getItemsList();
      } else {
        dispatch(warningSnackBar("Some Error Occured, Refresh and try again"));
        return;
      }
    }
  };

  const ViewProjectList = () => {
    let type = resolveProjectType(searchParams.get("project-type") || projectType, projectState);
    navigate(`/${PROJECT_MANAGEMENT}?project-type=${type}`);
  }

  const handleTaskChange = (data) => {
    setSelectedTaskData(data);
  }

  const writePermission = props.userAccessControl === 2 ? true : false;

  return (
    <div className="purchase-order-block">
      <div className="row">
        <div className="w-auto">
          <h2 className="content-heading text-uppercase">
            {reservedStock ? "Receive Reserved Stock" : "Receive Internal Stock"}
          </h2>
          <div className="col-12 breadcrumb-block p-0">
            <Breadcrumb>
              <Breadcrumb.Item onClick={ViewProjectList}>PROJECTS</Breadcrumb.Item>
              <Breadcrumb.Item onClick={viewProject}>{projectName}</Breadcrumb.Item>
              <Breadcrumb.Item active>
                {reservedStock ? "Receive Reserved Stock" : "Receive Internal Stock"}
              </Breadcrumb.Item>
            </Breadcrumb>

          </div>
        </div>

      </div>
      <div className="row">
        <div className="col-lg-6 col-md-8 ms-auto">
          <MultiSelect
            label="Select Task"
            placeholder="Select Task"
            isStage={true}
            isMulti={false}
            items={unifiedTasks}
            value={selectedTaskData}
            onChangeHandler={handleTaskChange}
            isSearchable={true}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="material-list-block mt-3">
            <div className="table-responsive">
              <Table bordered className="table-create table-material table-material-ch">
                <thead>
                  <tr>
                    <th className="w-auto">Item Description</th>
                    <th className="w-auto">Catalog</th>
                    <th>Category</th>
                    <th>Part No</th>
                    <th>UoM</th>
                    <th>Unit Cost</th>
                    <th>{reservedStock ? 'Available Reserved Stock' : 'Available Internal Stock'}</th>
                    <th>Enter Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.item}</td>
                        <td>{item.category}</td>
                        <td>{item.manufacturer}</td>
                        <td>{item.partNo}</td>
                        <td>{item.unit}</td>
                        <td>${item.recommendedCost || item.cost}</td>
                        <td>
                          {reservedStock ? parseFloat(item.reservedStock || 0) : parseFloat(item.deStock || 0)}
                        </td>
                        <td>
                          <CustomInput
                            className="input-block-sm"
                            type="number"
                            label="Stock"
                            value={item.newStock}
                            onChange={(e) => itemChangeHandler(e, index)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
        <div className="col-12 d-flex mt-5">
          {writePermission && (
            <Button type="submit" className="ms-auto me-3 secondarybtn" onClick={submitForm}>
              SAVE
            </Button>
          )}
          <Button type="submit" className="secondarybtn cancelbtn me-auto" onClick={viewProject}>
            CANCEL
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReceiveStock;